import React, { FC, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { PostProdutsDrawer } from '../../ui/posts/PostProductsDrawer';
import { ProductsUI } from '../../ui/posts/types';
import { useBackButton } from '../../utils/useBackButton';
import { DEFAULT_CLOSE_ANIMATION_DELAY } from '../constants';

export const PostProductsDialog: FC = () => {
    const { state } = useLocation();
    const products = state.products as ProductsUI;
    const onNavigateBack = useBackButton();

    const closeDialog = useCallback(() => {
        setTimeout(onNavigateBack, DEFAULT_CLOSE_ANIMATION_DELAY);
    }, [onNavigateBack]);

    return <PostProdutsDrawer products={products} handleClose={closeDialog} />;
};
